import React, { useEffect, useState } from 'react';
import { Table, Checkbox, Button, Alert } from 'antd';
import dayjs from 'dayjs';
import { restApi } from '../../../apis';

const PLAN_LIMIT = {
  Basic: 0,
  Economy: 0,
  Half: 5,
  Enterprise: Infinity,
  Premium: Infinity,
  Pilot: Infinity,
  Ambassador: Infinity,
};

const CategoryTable = (props) => {
  const { centerId } = props;
  const [categories, setCategories] = useState([]);
  const [selected, setSelected] = useState([]);
  const [plan, setPlan] = useState(""); // 실제 plan 이름
  const [planLimit, setPlanLimit] = useState(0);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!centerId) return;
    setLoading(true);
    restApi
      .get("/admin/category/check", { params: { centerId } })
      .then((res) => {
        const cats = res.data?.payload?.categories || [];
        const planInfo = res.data?.payload?.plan || {};
        setCategories(cats);

        setSelected(cats.filter((c) => c.checked).map((c) => c.id));

        const planName = planInfo.planName || "Economy";
        setPlan(planName);
        setPlanLimit(PLAN_LIMIT[planName] ?? 0);
        setEndDate(planInfo.endDate || null);
      })
      .finally(() => setLoading(false));
  }, [centerId]);

  const limit = PLAN_LIMIT[plan];

  // 오늘 날짜 이후인지 체크
  const isPlanValid = endDate ? dayjs(endDate).isAfter(dayjs(), "day") : false;

  const handleCheck = (id) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((cid) => cid !== id));
    } else {
      if (selected.length >= planLimit) {
        setError(`플랜 제한: 최대 ${planLimit}개 선택 가능`);
        setTimeout(() => setError(null), 1500);
        return;
      }
      setSelected([...selected, id]);
    }
  };

  const handleSave = () => {
    setLoading(true);
    restApi
      .post("/admin/category/check", { centerId, categoryIds: selected })
      .then(() => {
        setError(null);
        alert("저장 완료!");
      })
      .catch(() => setError("저장 실패"))
      .finally(() => setLoading(false));
  };

  // *** 컬럼 순서: 체크 → 카테고리명, 체크박스 컬럼 width 180 ***
  const columns = [
    {
      title: "체크",
      key: "checked",
      width: 150,
      align: "center",
      render: (_, record) => (
        <Checkbox
          checked={selected.includes(record.id)}
          disabled={
            plan === "basic" ||
            (!selected.includes(record.id) && selected.length >= limit)
          }
          onChange={() => handleCheck(record.id)}
        />
      ),
    },
    {
      title: "카테고리명",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            cursor: "pointer",
            userSelect: "none",
            padding: "8px 0", // 클릭 범위 넓힘
          }}
          onClick={() => handleCheck(record.id)}
        >
          {text}
        </div>
      ),
    },
  ];
  
  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: 16 }}>
        <b>
          플랜: {plan || "-"} &nbsp;|&nbsp; 만료일: {endDate ? dayjs(endDate).format("YYYY-MM-DD") : "-"} &nbsp;|&nbsp; 선택 {selected.length} / {planLimit === Infinity ? "∞" : planLimit}
        </b>
        {!isPlanValid && (
          <span style={{ color: "red", marginLeft: 12 }}>플랜 만료로 선택 불가</span>
        )}
      </div>
      {error && (
        <Alert type="warning" message={error} showIcon style={{ marginBottom: 12 }} />
      )}
      <Table
        rowKey="id"
        columns={columns}
        dataSource={categories}
        pagination={false}
        loading={loading}
        size="small"
      />
      <div style={{ textAlign: "right", marginTop: 24 }}>
        <Button
          type="primary"
          disabled={!isPlanValid || planLimit === 0}
          onClick={handleSave}
        >
          저장
        </Button>
      </div>
    </div>
  );
};

export default CategoryTable;
